import { MessageBox, Message } from "element-ui";
import Vue from "vue";
import { router } from "@/router";
const resizeMap = new WeakMap();
const observer = new ResizeObserver(entries => {
  for (let entry of entries) {
    // 获取被观察的 DOM 元素
    const target = entry.target;
    if (resizeMap.has(target)) {
      const callback = resizeMap.get(target);
      callback && callback(target);
    }
  }
});
export function handleConfirm(text, type) {
  return MessageBox.confirm(text, "操作确认", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: type
  });
}

/**
 * @author 封装 element-ui 消息提示
 * @param text
 * @param type
 * @returns {Promise}
 */
export function handleAlert(text, type) {
  return Message({
    showClose: true,
    message: text,
    type: type
  });
}
/**
 * Creates a debounced function that delays the invocation of the provided callback until after a specified delay has passed since the last time it was invoked.
 *
 * @param {Function} callback - The function to be debounced.
 * @param {number} [delay=500] - The number of milliseconds to delay. Defaults to 500ms.
 * @returns {Function} A new, debounced function.
 *
 * This utility is useful for scenarios where you want to limit the rate at which a function can fire, such as in response to window resizing or scrolling.
 */
export const debounce = (callback, delay = 500) => {
  let timeout;
  return function(...args) {
    const context = this; // 保存this指向
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback && callback.apply(context, args); // 正确绑定this和参数
    }, delay);
  };
};

export const assignObject = (target, source) => {
  if (
    !target ||
    !source ||
    typeof target !== "object" ||
    typeof source !== "object"
  ) {
    return { ...target };
  }
  const result = { ...target };
  Object.keys(result).forEach(key => {
    if (source.hasOwnProperty(key)) {
      result[key] = source[key];
    }
  });
  return result;
};

const cacheRouterPath = {
  get: function() {
    let path = localStorage.getItem("routerPath");
    router.push(path);
    return path;
  },
  set: function(value) {
    localStorage.setItem("routerPath", value);
  }
};

/**
 * 根据数据源，字段取值
 * @param res
 * @param field
 */
export const getDataByField = (res, field = "") => {
  const fiels = field.split(".");
  let result = res;
  for (let index = 0; index < fiels.length; index++) {
    const key = fiels[index];
    if (result && result[key]) {
      result = result[key];
    }
  }
  return result;
};
/**
 * 观察元素
 * @param callback
 * @param el
 */
export const useResize = (callback, el) => {
  if (typeof callback == "function" && typeof el == "object") {
    resizeMap.set(el, callback);
    observer.observe(el);
  }
};

export const getLabelByField = (arr = [], value, fieldOptions = {}) => {
  const { id = "id", label = "name" } = fieldOptions;
  const result = arr.find(item => item[id] === value);
  if (!result) {
    return "--";
  } else {
    return result[label];
  }
};
export { cacheRouterPath };
